<h1 mat-dialog-title>Choose a destination</h1>
<mat-dialog-content>
    @if (folders.length) {
        <table mat-table [dataSource]="folders">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Folder Name</th>
                <td mat-cell *matCellDef="let folder; let i = index">
                    <div
                        class="selectable-row-content"
                        (click)="navigateIntoFolder(folders[i])"
                        (keyup)="navigateIntoFolder(folders[i])"
                        tabindex="0">
                        <span class="folder-name-container">
                            <mat-icon>folder</mat-icon>
                            {{ folder.name }}
                        </span>
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let folder; let i = index; columns: displayedColumns" class="row"></tr>
        </table>
    } @else {
        <p class="no-folders-message">No folders to show</p>
    }
    <p class="path-container">
        <strong tabindex="0">Move to: {{ path.join(' > ') }}</strong>
    </p>
</mat-dialog-content>
<mat-dialog-actions class="actions-container">
    <button mat-raised-button [disabled]="!currentFolder" (click)="navigateBack()" type="button">Back</button>
    <div class="main-actions">
        <button
            mat-raised-button
            color="primary"
            [disabled]="(currentFolder?.id ?? 0) === (originFolderId ?? 0)"
            (click)="move()"
            type="button">
            Move
        </button>
        <button mat-raised-button color="secondary" (click)="dialogRef.close()" type="button">Cancel</button>
    </div>
</mat-dialog-actions>
